import React, { useState } from 'react';

import Box from '@mui/material/Box';
import PaymentFlowStates from './components/PaymentFlowStates';
import PaymentsGrid from './components/Grid';

const Workspace = () => {
  const [showGrid, setShowGrid] = useState(false);
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <PaymentFlowStates setShowGrid={setShowGrid} />
      {showGrid && <PaymentsGrid />}
    </Box>
  );
};

export default Workspace;
